import styled from 'styled-components';
import { spacing } from 'ui/theme';
import { ChevronDownSmall } from 'ui/icons';
import { GhostButton } from 'ui/button';
import { ExpandModes, useExpansionContext } from 'utils/contexts/expansion';

import { useTranslation } from '../../../hooks';

type ExpansionToggleButtonProps = {
  hasMeterChart?: boolean;
};

const StyledButton = styled(GhostButton)`
  grid-column: 1 span 2;
  justify-self: center;

  [data-meter-chart='true'] {
    grid-column: 1 / span 4;
  }

  svg {
    margin-left: ${spacing.quarter};
    transition: 0.25s transform ease;
    [data-expanded='true'] {
      transform: rotate 180deg;
    }
  }
`;

export const ExpansionToggleButton = ({ hasMeterChart = false }: ExpansionToggleButtonProps) => {
  const { mode, toggle } = useExpansionContext();
  const { t } = useTranslation();
  const isExpanded = mode === ExpandModes.expand;

  return (
    <StyledButton
      onClick={toggle}
      data-expanded={isExpanded}
      data-test="expansion-toggle-button"
      data-meter-chart={hasMeterChart}
    >
      {t(isExpanded ? 'insights.collapse' : 'insights.expand')}
      <ChevronDownSmall />
    </StyledButton>
  );
};
